import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import SelectInput from "../../../Components/Inputs/SelectInput";

const AmenityFilterSelector = (props) => {
    const dispatch = useDispatch();

    var amenityOptions;
    if (props.category && props.category !== 'all') {
        amenityOptions = useSelector(state => state.module.BOOKINGS.common.formOptions.categoryAmenities[props.category]);
    } else {
        amenityOptions = useSelector(state => state.module.BOOKINGS.common.formOptions.amenities);
    }

    if (props.includeAll && amenityOptions) {
        amenityOptions = [
            {
                value: null,
                label: 'All',
            },
            ...amenityOptions
        ];
    }

    const getValueOption = () => {
        if (typeof(props.value) == 'object') {
            return props.value;
        }

        if (amenityOptions) {
            let selected = amenityOptions.filter(option => option.value == props.value);

            if (selected.length > 0) {
                return selected[0];
            }
        }
        return null;
    }

    return (
        <SelectInput
            name={props.name}
            options={amenityOptions}
            value={getValueOption()}
            onChange={props.onChange}
            classNamePrefix='filter-row-selector'
            menuPortalTarget={document.body}
        />
    )
}

AmenityFilterSelector.defaultProps = {
    name: 'amenity',
    includeAll: false
}

export default AmenityFilterSelector;
